import styled from "styled-components";

const WOFShellBox = styled.div`
    position: relative;
    background: url(${({theme}) => theme.images.wheelOfFortune.shell.toString()}) no-repeat center;
    background-size: cover;
    
    padding: 8px;
    height: 50px;
    width: 50px;
`;

export default WOFShellBox;